import proxy from '../proxy';
import { AppConfig } from '../../Models/AppConfig';
// import { dataLinkLocalBackEndUrl } from '../config';

export let dataLinkBackendUrl: string;

export default function init(config: AppConfig) {
  dataLinkBackendUrl = config.dataLinkBackendUrl;
  /* if (process.env.NODE_ENV === 'development') {
    dataLinkBackendUrl = dataLinkLocalBackEndUrl;
  } */
  if (!dataLinkBackendUrl) {
    return;
  }

  proxy.init(config.dataLinkBackendUrl);  
}
